import { render, staticRenderFns } from "./CustomUploader.vue?vue&type=template&id=58cb9b70&scoped=true&"
import script from "./CustomUploader.vue?vue&type=script&lang=ts&"
export * from "./CustomUploader.vue?vue&type=script&lang=ts&"
import style0 from "./CustomUploader.vue?vue&type=style&index=0&id=58cb9b70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cb9b70",
  null
  
)

export default component.exports